module.exports = __webpack_public_path__ + "img/xdjsq.d283d836.png";